import React, { Component, createRef, ReactNode } from 'react';
import Slider from 'react-slick';
import clsx from 'clsx';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme) => ({
  root: {
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(-1),
  },
  card: {
    margin: theme.spacing(2, 0.5),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(2, 1),
    },
  },
});

export type Props = {
  classes: { [key: string]: string };
  theme: Theme;
};

interface SlickSlider extends Slider {
  readonly innerSlider: SlickInnerSlider;
}

interface SlickInnerSlider {
  props: {
    autoplay: boolean;
    autoplaySpeed: number;
  };

  state: {
    currentSlide: number;
    autoplaying: string;
    dragging: boolean;
  };

  autoplayTimer: number | null;
  play: TimerHandler;

  pause: (type: string) => void;
}

class ListSlick extends Component<Props> {
  sliderRef = createRef<SlickSlider>();

  settings = (theme) => ({});

  slickItemsRenderer(): ReactNode {
    return <div />;
  }

  handleReinit = () => {
    // Slider is destroyed when slidesToShow has a decimal point in finite mode.
    // Workaround is to assign an integer to currentSlide
    const innerSlider = this.sliderRef.current?.innerSlider;
    if (innerSlider && !Number.isInteger(innerSlider.state.currentSlide)) {
      innerSlider.state.currentSlide = Math.trunc(
        innerSlider.state.currentSlide,
      );
    }

    if (innerSlider?.props.autoplay) {
      if (
        innerSlider.state.dragging &&
        innerSlider.state.autoplaying === 'playing'
      ) {
        // Pause autoplay while dragging
        innerSlider.pause('paused');
      } else if (
        !innerSlider.state.dragging &&
        innerSlider.state.autoplaying !== 'playing'
      ) {
        // Start autoPlay while not dragging and not playing
        // This refers to react-slick/InnerSlider#autoPlay
        innerSlider.autoplayTimer && clearInterval(innerSlider.autoplayTimer);
        innerSlider.autoplayTimer = setInterval(
          innerSlider.play,
          innerSlider.props.autoplaySpeed + 50,
        );
        innerSlider.state.autoplaying = 'playing';
      }
    }
  };

  render() {
    const { classes, theme } = this.props;
    return (
      <Slider
        {...this.settings(theme)}
        className={clsx(classes.root, 'service-list-slick')}
        onReInit={this.handleReinit}
        ref={this.sliderRef}
      >
        {this.slickItemsRenderer()}
      </Slider>
    );
  }
}

export default ListSlick;
